var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 49,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M48.25 24.629c0 12.979-10.521 23.5-23.5 23.5s-23.5-10.521-23.5-23.5 10.521-23.5 23.5-23.5 23.5 10.521 23.5 23.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M34.557 16.154a3.14 3.14 0 0 1 2.22 2.219c.522 1.957.524 6.042.524 6.042s0 4.085-.525 6.042a3.14 3.14 0 0 1-2.219 2.22c-1.957.524-9.807.524-9.807.524s-7.85 0-9.807-.525a3.14 3.14 0 0 1-2.22-2.219c-.524-1.957-.524-6.042-.524-6.042s0-4.085.525-6.042a3.14 3.14 0 0 1 2.22-2.22c1.956-.524 9.806-.524 9.806-.524s7.85 0 9.807.525m-5.799 8.261-6.52 3.765v-7.53z",
  clipRule: "evenodd"
})));
export default SvgYoutube;